import { compose } from 'redux';
import { curry, head, property } from 'lodash-es';
import { jsonApi } from '../http-request';
import { filter, map, propEq, propFromSelector } from '../utils';

const collection = jsonApi.selectors.collection('names');
const findResource = jsonApi.findResource(collection);

const findResourceAndHydrate = curry((fn, state) =>
  compose(
    jsonApi.utils.hydrate(state),
    findResource(fn)
  )(state)
);

const createFacade = selector => {
  const propFromResource = propFromSelector(selector);

  const id = propFromResource('id');
  const first = propFromResource('first');
  const last = propFromResource('last');
  const middle = propFromResource('middle');
  const middleInitial = compose(
    head,
    middle
  );
  const suffix = propFromResource('suffix');
  const createdAt = propFromResource('created_at');

  // TODO: Refactor using compose and partially applied versions of join, trim, etc.
  const fullName = state =>
    [first(state), middleInitial(state), last(state), suffix(state)]
      .join(' ')
      .replace(/\ +(?= )/g, '')
      .trim();

  return {
    id,
    first,
    last,
    middle,
    suffix,
    fullName,
    createdAt,
  };
};

export const byId = id =>
  createFacade(findResourceAndHydrate(propEq('id', String(id))));

export const allByUserId = curry((id, state) =>
  compose(
    map(byId),
    map(property('id')),
    filter(propEq('attributes.user_id', Number(id))),
    collection
  )(state)
);

const current = state => ({ ...state.name });
export const selectedId = compose(
  property('selectedId'),
  current
);
